import { gql } from './apollo';

export const GET_SKUS_FOR_PROPERTY = gql`
    query ($property_id: MultiTypeInput!) {
        table(
            name: "sku"
            join: [{ table: "sku_property", fk: "sku_id", joinFk: "id" }]
            filter: [
                { table: "sku_property", left: "property_id", right: $property_id, expression: "=" }
            ]
            orderBy: "sku_id"
            orderByDirection: DESC
            limit: 100
        )
    }
`;

export const GET_SKU_BY_ID = gql`
    query ($id: MultiTypeInput!) {
        table(name: "sku", filter: [{ left: "id", right: $id, expression: "=" }], limit: 1)
    }
`;
